import React, { useEffect, useRef, useState } from "react";

const Experience = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const milestoneRefs = useRef([]);
  const milestones = [
    { year: "JUNE 2026", label: "Current role", title: "Graduate Engineer Trainee", org: "SYNERGECH", text: "Building practical engineering experience and contributing to thoughtful, useful products.", tag: "NOW" },
    { year: "2025", label: "Independent", title: "Freelance Developer", org: "Zionarch Architects", text: "Shipped a production website with email workflows, storage, and a calmer client experience.", tag: "WORK" },
    { year: "2024", label: "First launch", title: "Full Stack Developer Intern", org: "PROPZING", text: "Built an AI-powered real estate platform with Next.js, Supabase, and Cloudinary.", tag: "WORK" },
    { year: "2023", label: "Foundation", title: "B.Tech Information Technology", org: "Coimbatore", text: "Started turning curiosity into a craft: interfaces, systems, and the details between them.", tag: "EDUCATION" },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveIndex(Number(entry.target.dataset.index));
          }
        });
      },
      { rootMargin: "-35% 0px -45% 0px", threshold: 0 }
    );

    milestoneRefs.current.forEach((milestone) => {
      if (milestone) observer.observe(milestone);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <section name="Experience" className="bg-[#17201c] text-[#f4f0e8]">
      <div className="section-shell">
        <div className="mb-16 flex flex-col justify-between gap-6 sm:flex-row sm:items-end">
          <div><p className="font-mono text-xs uppercase tracking-[.25em] text-[#c9d84a]">02 — The path so far</p><h2 className="section-heading mt-3 text-[#f4f0e8]">A trail of <em className="text-[#e65335]">signals.</em></h2></div>
          <p className="max-w-sm text-sm leading-7 text-[#aeb7ad]">Not a straight line. More like a radio signal: learn, ship, listen, and find the next frequency.</p>
        </div>
        <div className="relative">
          <div className="journey-line absolute left-4 top-4 h-[calc(100%-2rem)] w-px md:left-1/2" />
          <div className="journey-progress absolute left-4 top-4 z-[1] w-px md:left-1/2" style={{ height: `${((activeIndex + 1) / milestones.length) * 100}%` }} />
          <div className="space-y-12 md:space-y-0">
            {milestones.map((item, index) => (
              <article
                key={item.year}
                ref={(element) => { milestoneRefs.current[index] = element; }}
                data-index={index}
                className={`journey-chapter relative md:flex md:min-h-[260px] md:items-center ${index % 2 ? "md:flex-row-reverse" : ""} ${index <= activeIndex ? "is-visible" : ""}`}
              >
                <div className={`journey-node absolute left-[9px] top-8 z-10 h-3 w-3 rounded-full bg-[#c9d84a] md:left-1/2 md:-translate-x-1/2 ${index === activeIndex ? "journey-node-active" : ""}`} />
                <div className="pl-12 md:w-1/2 md:px-12 md:pl-0">
                  <div className="journey-card rounded-2xl border border-[#435047] bg-[#202b25] p-6 transition hover:border-[#e65335]">
                    <div className="mb-4 flex items-center justify-between gap-4"><span className="font-mono text-xs text-[#e65335]">{item.tag}</span><span className="font-mono text-xs text-[#aeb7ad]">{item.year}</span></div>
                    <p className="mb-3 font-mono text-xs uppercase tracking-[.2em] text-[#aeb7ad]">Chapter 0{index + 1}</p><h3 className="text-2xl font-bold">{item.title}</h3><p className="mt-1 text-[#c9d84a]">{item.org} · {item.label}</p><p className="mt-4 leading-7 text-[#aeb7ad]">{item.text}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
export default Experience;
